export default __webpack_public_path__ + "static/aboutPageBg-1120ff57d0ff63b90d8073c7250b2b29.png";